module.exports = __webpack_public_path__ + "img/5.ff93c3a1.png";